import { createFileRoute } from "@tanstack/react-router";
import { ModuleGuard } from "@/components/auth/ModuleGuard";
import Prospects from "@/pages/Prospects";

export const Route = createFileRoute("/_app/clients/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModuleGuard module="prospects">
      <Prospects mode="clients" />
    </ModuleGuard>
  );
}
